/** @jsx jsx */
import { css, jsx } from "@emotion/core"

export function Hr() {
  return (
    <div
      css={css`
        height: 1px;
        background-color: #eee;
      `}
    />
  )
}
